var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"weblink"}},[_c('div',{attrs:{"id":"iframe-wrap"}},[(_vm.loaded)?_c('iframe',{style:(_vm.iframe.style),attrs:{"src":_vm.iframe.src,"height":_vm.iframe.style.height,"width":_vm.iframe.style.width,"frameborder":"0"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47868eb7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio/WebLink.vue
// module id = null
// module chunks = 